import { render } from "./2022-10-16-DNS.md?vue&type=template&id=4e38d8a0"
const script = {}
script.render = render

export default script